















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import CreateCaseLabelDto from "../../../store/entities/case-labels/create-case-label";
import PdfBarcodeDocument from "../../components/pdf-barcode-document.vue";
import _ from "lodash";

@Component({
  components: {
    "pdf-barcode-document": PdfBarcodeDocument,
  },
})
export default class CreateCaseLabel extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  caseLabels: CreateCaseLabelDto = new CreateCaseLabelDto();
  current: number = 0;
  spinShow: boolean = false;
  createdCaseLabelCodes = [];
  pageTitlePopup: string = "create";
  activeStep(next: boolean) {
    if (next && this.current < 1) {
      this.current++;
    }
    if (!next && this.current > 0) {
      this.current--;
    }
  }
  nextStep() {
    this.activeStep(true);
  }

  backStep() {
    this.activeStep(false);
  }
  get printData() {
    return {
      pages: this.printCaseLabelCodes,
      pagesTitle: this.pageTitlePopup,
      objectType: "caseLabel",
    };
  }
  get printCaseLabelCodes() {
    return this.createdCaseLabelCodes;
  }
  save() {
    this.spinShow = true;
    (this.$refs.caseLabelForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.$store
          .dispatch({
            type: "caseLabel/create",
            data: this.caseLabels,
          })
          .then((ret) => {
            this.createdCaseLabelCodes = ret;
            (this.$refs.caseLabelForm as any).resetFields();
            this.succeed();
            this.spinShow = false;
          })
          .catch(() => {
            this.spinShow = false;
          });
      }
    });
  }
  succeed() {
    this.$emit("download-file-printer");
    this.activeStep(true);
  }
  cancel() {
    this.current = 0;
    this.$emit("input", false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  created() {}
  caseLabelRules = {
    qty: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Qty")),
        trigger: "blur",
      },
      {
        type: "number",
        max: 200,
        min: 1,
        message: this.L("Error.RequiredField", undefined, this.L("Qty")),
      },
    ],
  };
}
